import React from 'react';
import ActivityContainer from './ActivityContainer';
import ActivityPublicContainer from './ActivityPublicContainer';

const ActivityView = () => {
    return (
        <div>
            {<ActivityContainer/>}
        </div>);
}

export default ActivityView